// extracted by mini-css-extract-plugin
export default {"root":"EditorialDashboardPage_root__bmHTP","tabs":"EditorialDashboardPage_tabs__PjxVL","tab":"EditorialDashboardPage_tab__1ds+l"};